var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"fill-height":""}},[(_vm.bottomNav === 'reset_password')?_c('tab-reset-password'):_vm._e()],1)],1),_vm._v(" "),_c('v-bottom-nav',{attrs:{"active":_vm.bottomNav,"color":_vm.color,"value":true,"app":"","fixed":"","dark":""},on:{"update:active":function($event){_vm.bottomNav=$event}}},[_c('v-btn',{attrs:{"dark":"","value":"reset_password"}},[_c('span',[_vm._v("Reset password")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/pages/Settings.vue?vue&type=template&id=7eee6754&scoped=true&
// module id = 926
// module chunks = 0